/**
 * Darkens a hex color by a given percentage.
 * @param {string} color - The hex color to darken.
 * @param {number} amount - The percentage to darken the color by (0-100).
 * @returns {string} - The darkened hex color.
 */
export const darkenColor = (color: string, amount = 30) => {
  // Remove the hash at the start if it's there
  color = color.replace(/^#/, "");

  // Parse the r, g, b values
  let r = parseInt(color.substring(0, 2), 16);
  let g = parseInt(color.substring(2, 4), 16);
  let b = parseInt(color.substring(4, 6), 16);

  // Calculate the amount to darken
  const darkenAmount = amount / 100;

  // Apply the darkening
  r = Math.max(0, Math.min(255, Math.floor(r * (1 - darkenAmount))));
  g = Math.max(0, Math.min(255, Math.floor(g * (1 - darkenAmount))));
  b = Math.max(0, Math.min(255, Math.floor(b * (1 - darkenAmount))));

  // Convert back to hex and return
  // @ts-ignore
  const toHex = n => n.toString(16).padStart(2, "0");
  return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
};
